import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, InputAdornment, TextField, useMediaQuery } from "@mui/material";
import momentJalaali from "moment-jalaali";
import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker2";
import { useSelector } from "react-redux";
import { toIsoString } from "../../scripts/functions";

const DateInput = ({
  value,
  onChange,
  label,
  min,
  timePicker = false,
  possition,
}) => {
  const startTimeCalender = useRef();
  const [valueStatDate, setValueStatDate] = useState(0);
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);

  const getDate = (currentDate) => {
    if (!currentDate) return;
    let string = new Date(currentDate).toLocaleDateString("en-US-u-ca-persian");

    string =
      string.split("/")[2] +
      "/" +
      string.split("/")[0] +
      "/" +
      string.split("/")[1] +
      ` ${String(new Date(currentDate).getHours()).padStart(2, "0")}:${String(
        new Date(currentDate).getMinutes()
      ).padStart(2, "0")}`;
    return momentJalaali(string, "jYYYY/jM/jD HH:mm");
  };
  const isMd = useMediaQuery("(min-width:900px)");

  const css = `
  
  .tether-element {
    top: 40px !important;
    transform: translateX(-50%) !important;
    left: 50% !important;
  }
  `;
  const css2 = `
  
  .tether-element {
    bottom: 60px !important;
    transform: translateX(-50%) !important;
    left: 50% !important;
    top: unset !important;
  }
  `;
  const css3 = `
  
  .calendarContainer {
    background-color: #2a3042 !important;
  }
  .calendarContainer .heading>button:hover{
    background-color: #161949;

  }
  `;
  return (
    <>
      {possition !== "bottom" && !isMd && <style>{css}</style>}
      {possition === "bottom" && !isMd && <style>{css2}</style>}
      {themeDisplay === "dark" && <style>{css3}</style>}
      <Box
        sx={{
          ".datepicker-input": {
            display: "none",
          },
          /*       ".calendarContainer":{
            background:"#000 !important"
          } */
        }}
      >
        {" "}
        <DatePicker
          timePicker={false}
          value={getDate(value)}
          isGregorian={false}
          min={min}
          ref={startTimeCalender}
          onChange={(value) => {
            if (value) {
              onChange(toIsoString(value._d));
              setValueStatDate(value._d.toLocaleDateString("fa"));
            }
          }}
        />
        <TextField
          onMouseUp={() => startTimeCalender.current?.setOpen(true)}
          InputProps={{
            inputProps: {
              style: { textAlign: "right", width: "100%" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <Box
                  component={CalendarMonthIcon}
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#e6e5fb" : "#495057",
                  }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          value={valueStatDate ? valueStatDate : ""}
          label={label}
          autoComplete="off"
          fullWidth
        />
      </Box>
    </>
  );
};

export default DateInput;
